





















































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
export default Vue.extend({
  components: {
    AppTableRow,
  },
  props: ["source"],
  setup() {
    return {};
  },
});
